var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPatterns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 845,
    viewBox: "0 0 278 845",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0697 146.48L71.2559 185.386L116.492 146.48H26.0697Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0736 289.926L71.2598 328.831L116.496 289.926H26.0736Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0794 433.391L71.2656 472.295L116.502 433.391H26.0794Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0736 555.038L71.2598 516.133L116.496 555.038H26.0736Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0736 698.483L71.2598 659.578L116.496 698.483H26.0736Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.424 553.933L237.962 519.891L277.543 553.933H198.424Z",
    fill: "#008894",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42 721.367L237.958 755.409L277.539 721.367H198.42Z",
    fill: "#008894",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.422 697.378L237.96 663.336L277.541 697.378H198.422Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3316 788.93L-11.8477 837.561L44.6953 788.93L-68.3316 788.93Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3063 645.492L-11.8238 694.124L44.7207 645.492H-68.3063Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3063 773.265L-11.8238 724.633L44.7207 773.265H-68.3063Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3063 502.047L-11.8238 550.679L44.7207 502.047H-68.3063Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3023 629.827L-11.8199 581.195L44.7246 629.827H-68.3023Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3082 358.602L-11.8258 407.233L44.7188 358.602H-68.3082Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3023 486.373L-11.8199 437.742L44.7246 486.373H-68.3023Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.538 793.797L154.723 832.702L199.959 793.797H109.538Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.798 650.359L154.984 689.264L200.221 650.359H109.798Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.792 768.405L154.979 729.5L200.215 768.405H109.792Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.792 506.914L154.979 545.819L200.215 506.914H109.792Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.796 624.96L154.982 586.055L200.219 624.96H109.796Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.798 481.515L154.984 442.609L200.221 481.515H109.798Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3004 215.145L-11.8179 263.776L44.7266 215.145H-68.3004Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3023 342.921L-11.8199 294.289L44.7246 342.921H-68.3023Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3004 71.6992L-11.8179 120.331L44.7266 71.6992H-68.3004Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.3063 199.479L-11.8238 150.848L44.7207 199.479H-68.3063Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.693 363.465L154.879 402.37L200.115 363.465H109.693Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.691 220.016L154.877 258.921L200.113 220.016H109.691Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.693 338.065L154.879 299.16L200.115 338.065H109.693Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.691 76.582L154.877 115.487L200.113 76.582H109.691Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.687 194.612L154.873 155.707L200.109 194.612H109.687Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0755 720.273L71.2617 759.179L116.498 720.273H26.0755Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0736 576.828L71.2598 615.733L116.496 576.828H26.0736Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0755 411.601L71.2617 372.695L116.498 411.601H26.0755Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42 407.362L237.958 373.32L277.539 407.362H198.42Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0794 268.139L71.2656 229.234L116.502 268.139H26.0794Z",
    fill: "#008894",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.422 263.913L237.96 229.871L277.541 263.913H198.422Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.424 150.727L237.962 184.769L277.543 150.727H198.424Z",
    fill: "#008894",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0755 124.694L71.2617 85.7891L116.498 124.694H26.0755Z",
    fill: "#008894",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2586 841.92L71.4449 803.016L116.68 841.92H26.2586Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.1755 56.0224L-11.693 7.39063L44.8516 56.0224H-68.1755Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.862 51.1783L155.048 12.2734L200.283 51.1783H109.862Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.495 3.03906L71.6813 41.9446L116.916 3.03906L26.495 3.03906Z",
    fill: "#F5C4AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.881 4.13672L238.419 38.1788L278 4.13672L198.881 4.13672Z",
    fill: "#2C2A7A",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPatterns);
export default __webpack_public_path__ + "static/media/left-Patterns.2c32f25849ad5db43c67d4301656d2e4.svg";
export { ForwardRef as ReactComponent };